import api from '@/lib/api'

export default {
  namespaced: true,
  state: {
    recommendedProducts: [],
    productsByCategory: [],
    productDetails: {
      companyProfile: [],
      description: [],
      productImage: [],
      productDetail: []
    }
  },
  mutations: {
    setRecommendedProducts(state, products) {
      state.recommendedProducts = products;
    },
    setProductsByCategory(state, products) {
      state.productsByCategory = products;
    },
    setProductDetails(state, product) {
      state.productDetails = product;
    }
  },
  actions: {
    async fetchRecommendedProducts({ commit }) {
      const response = await api.getRecommendedProducts()
      commit('setRecommendedProducts', response.data.Result)

      var evt = new CustomEvent('owl-initialize', {  });
  		window.dispatchEvent(evt);
    },
    async fetchProductsByCategory({ commit }, { categoryId }) {
      const response = await api.getProductsByCategory(categoryId)
      commit('setProductsByCategory', response.data.Result)
    },
    async fetchProductDetails({ commit }, { productId }) {
      const response = await api.getProductDetails(productId);
      //console.log('response fetchProductDetails ::::::::::: ', response);

      commit('setProductDetails', {
        companyProfile : response.data.companyProfile,
        description : response.data.description,
        productDetail : response.data.productDetail,
        productImage : response.data.productImage,
      })
    },
    async addRfq({ commit }, { categoryTypeId, title, quantity, toTenantId, rfqBody, fromUserId, productName, productServiceId, productUomId, attachmentUrl, fileName }) {
      const response = await api.addRfq(categoryTypeId, title, quantity, toTenantId, rfqBody, fromUserId, productName, productServiceId, productUomId, attachmentUrl, fileName)
    },
    async addInquiry({ commit }, { title, toTenantId, rfqBody, fromUserId, attachmentUrl, fileName}) {
      const response = await api.addInquiry(title, toTenantId, rfqBody, fromUserId, attachmentUrl, fileName)
      return response;
    },
    async addChat({ commit }, { selectedUser, messag, fromUserId}) {
      const response = await api.addChat(selectedUser, messag, fromUserId)
    },
    async addAttachmentInquiry({ commit }, { attachment }) {
      const response = await api.uploadFileInquiryDoc(attachment);

      return response;
    },
    async addAttachmentRfq({ commit }, { attachment, typeRfq }) {

      if (typeRfq == 'service') {
        // console.log('masuk service');
        const response = await api.uploadFileServiceRfqDoc(attachment);
        return response;
      } else {
        // console.log('masuk products ');
        const response = await api.uploadFileProductRfqDoc(attachment);
        return response;
      }

    },
    async pushInquiryEmail({ commit }, { tenantInquiryId, tenantInquiryHistoryId }) {
      await api.pushEmailInquiry(tenantInquiryId, tenantInquiryHistoryId);
    }
  }
}
